export default {
  MOSTRAR_OCULTAR_MENU(state) {
    state.drawer = !this.state.drawer;
  },
  MOSTRAR_MENU(state) {
    state.drawer = true;
  },
  OCULTAR_MENU(state) {
    state.drawer = false;
  }
};
